export const COMMENT_KEY = 'comment';
export const CLEARED_LIVE_KEY = 'Cleared Live';
export const CLEARED_NON_LINEAR_KEY = 'Cleared Non Linear';
export const LIVE_VIEW_TYPE = 'LIVE';
export const POST_VIEW_TYPE = 'POST';
export const DETAIL_VIEW_TYPE = 'DETAIL';
export const COMMENT_UUID = '0a5b13a1-6c24-4a06-97dd-a156e92b384a';
